"use client";

import { useEffect, useSyncExternalStore } from "react";
import { useFavorieten } from "@/components/favorieten";
import { favorietSleutel } from "@/lib/favorieten";
import {
  abonneerSoorten,
  soortenMomentopname,
  soortenServerMomentopname,
  werkBij,
} from "@/lib/meldingen-client";

// Houdt de server op de hoogte van wat je volgt, op elke pagina.
//
// Wat je volgt staat op je telefoon; de server weet het alleen omdat de app
// het opstuurt - teams, en sinds oktober 2026 ook wedstrijden en klassen. Dat
// gebeurde tot 2 oktober alleen op de pagina Meldingen. Wie daarna op het
// live-scherm of een teampagina een ster zette, kreeg over dat team nooit een
// melding - tot hij toevallig weer op Meldingen kwam. Op Staphorst bleek dat:
// alle zeven aanmeldingen hadden een lijst van begin september, en de uitkijk
// meldde de hele avond "0 meldingen".
//
// Nu bij elke wijziging, en één keer bij het openen van de app. werkBij doet
// niets als dit toestel geen meldingen aan heeft, of als er niets veranderd is.
// Dat laatste ook voor wie de app al had: de eerste keer na deze versie gaan
// de wedstrijden en klassen vanzelf mee.
export function MeldingenBijwerken() {
  const { favorieten, geladen } = useFavorieten();
  const soorten = useSyncExternalStore(
    abonneerSoorten,
    soortenMomentopname,
    soortenServerMomentopname,
  );

  // Op een tekst en niet op de lijst zelf, zodat het effect alleen afgaat als
  // er werkelijk iets veranderd is.
  const sleutel = `${favorieten.map(favorietSleutel).sort().join(",")}|${[...soorten].sort().join(",")}`;

  useEffect(() => {
    if (!geladen) return;
    void werkBij(favorieten, soorten);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sleutel vat favorieten en soorten samen
  }, [sleutel, geladen]);

  return null;
}
